/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "eventos";

/**
 * Vercao 1.0
 * - Adicioando Pais e Pavimento Tipo
 * Vercao 0.1
 * - Definicao da mensagem 'RevGeo', com seus respectivos campos
 * - Enum Resultados adicionado para verificar o tipo de retorno do servico de RevGeo.
 */

export interface RevGeo {
  resultado: RevGeo_Resultados;
  logradouro: string;
  faixaNumeracao: string;
  cep: string;
  municipio: string;
  uf: string;
  pais: string;
  pavimentoTipo: RevGeo_PavimentoTipo;
  velocidadeMaximaVia: number;
  municipioId: number;
  bairro: string;
}

export enum RevGeo_Resultados {
  ENCONTRADO = 0,
  NAO_ENCONTRADO = 1,
  ERRO = 2,
  UNRECOGNIZED = -1,
}

export function revGeo_ResultadosFromJSON(object: any): RevGeo_Resultados {
  switch (object) {
    case 0:
    case "ENCONTRADO":
      return RevGeo_Resultados.ENCONTRADO;
    case 1:
    case "NAO_ENCONTRADO":
      return RevGeo_Resultados.NAO_ENCONTRADO;
    case 2:
    case "ERRO":
      return RevGeo_Resultados.ERRO;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RevGeo_Resultados.UNRECOGNIZED;
  }
}

export function revGeo_ResultadosToJSON(object: RevGeo_Resultados): string {
  switch (object) {
    case RevGeo_Resultados.ENCONTRADO:
      return "ENCONTRADO";
    case RevGeo_Resultados.NAO_ENCONTRADO:
      return "NAO_ENCONTRADO";
    case RevGeo_Resultados.ERRO:
      return "ERRO";
    case RevGeo_Resultados.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum RevGeo_PavimentoTipo {
  Urbano = 0,
  Rodoviario = 1,
  UNRECOGNIZED = -1,
}

export function revGeo_PavimentoTipoFromJSON(object: any): RevGeo_PavimentoTipo {
  switch (object) {
    case 0:
    case "Urbano":
      return RevGeo_PavimentoTipo.Urbano;
    case 1:
    case "Rodoviario":
      return RevGeo_PavimentoTipo.Rodoviario;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RevGeo_PavimentoTipo.UNRECOGNIZED;
  }
}

export function revGeo_PavimentoTipoToJSON(object: RevGeo_PavimentoTipo): string {
  switch (object) {
    case RevGeo_PavimentoTipo.Urbano:
      return "Urbano";
    case RevGeo_PavimentoTipo.Rodoviario:
      return "Rodoviario";
    case RevGeo_PavimentoTipo.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseRevGeo(): RevGeo {
  return {
    resultado: 0,
    logradouro: "",
    faixaNumeracao: "",
    cep: "",
    municipio: "",
    uf: "",
    pais: "",
    pavimentoTipo: 0,
    velocidadeMaximaVia: 0,
    municipioId: 0,
    bairro: "",
  };
}

export const RevGeo = {
  encode(message: RevGeo, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.resultado !== 0) {
      writer.uint32(8).int32(message.resultado);
    }
    if (message.logradouro !== "") {
      writer.uint32(18).string(message.logradouro);
    }
    if (message.faixaNumeracao !== "") {
      writer.uint32(26).string(message.faixaNumeracao);
    }
    if (message.cep !== "") {
      writer.uint32(34).string(message.cep);
    }
    if (message.municipio !== "") {
      writer.uint32(42).string(message.municipio);
    }
    if (message.uf !== "") {
      writer.uint32(50).string(message.uf);
    }
    if (message.pais !== "") {
      writer.uint32(58).string(message.pais);
    }
    if (message.pavimentoTipo !== 0) {
      writer.uint32(64).int32(message.pavimentoTipo);
    }
    if (message.velocidadeMaximaVia !== 0) {
      writer.uint32(72).int32(message.velocidadeMaximaVia);
    }
    if (message.municipioId !== 0) {
      writer.uint32(80).int32(message.municipioId);
    }
    if (message.bairro !== "") {
      writer.uint32(90).string(message.bairro);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RevGeo {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRevGeo();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.resultado = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.logradouro = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.faixaNumeracao = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.cep = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.municipio = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.uf = reader.string();
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.pais = reader.string();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.pavimentoTipo = reader.int32() as any;
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.velocidadeMaximaVia = reader.int32();
          continue;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.municipioId = reader.int32();
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.bairro = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RevGeo {
    return {
      resultado: isSet(object.resultado) ? revGeo_ResultadosFromJSON(object.resultado) : 0,
      logradouro: isSet(object.logradouro) ? String(object.logradouro) : "",
      faixaNumeracao: isSet(object.faixaNumeracao) ? String(object.faixaNumeracao) : "",
      cep: isSet(object.cep) ? String(object.cep) : "",
      municipio: isSet(object.municipio) ? String(object.municipio) : "",
      uf: isSet(object.uf) ? String(object.uf) : "",
      pais: isSet(object.pais) ? String(object.pais) : "",
      pavimentoTipo: isSet(object.pavimentoTipo) ? revGeo_PavimentoTipoFromJSON(object.pavimentoTipo) : 0,
      velocidadeMaximaVia: isSet(object.velocidadeMaximaVia) ? Number(object.velocidadeMaximaVia) : 0,
      municipioId: isSet(object.municipioId) ? Number(object.municipioId) : 0,
      bairro: isSet(object.bairro) ? String(object.bairro) : "",
    };
  },

  toJSON(message: RevGeo): unknown {
    const obj: any = {};
    if (message.resultado !== 0) {
      obj.resultado = revGeo_ResultadosToJSON(message.resultado);
    }
    if (message.logradouro !== "") {
      obj.logradouro = message.logradouro;
    }
    if (message.faixaNumeracao !== "") {
      obj.faixaNumeracao = message.faixaNumeracao;
    }
    if (message.cep !== "") {
      obj.cep = message.cep;
    }
    if (message.municipio !== "") {
      obj.municipio = message.municipio;
    }
    if (message.uf !== "") {
      obj.uf = message.uf;
    }
    if (message.pais !== "") {
      obj.pais = message.pais;
    }
    if (message.pavimentoTipo !== 0) {
      obj.pavimentoTipo = revGeo_PavimentoTipoToJSON(message.pavimentoTipo);
    }
    if (message.velocidadeMaximaVia !== 0) {
      obj.velocidadeMaximaVia = Math.round(message.velocidadeMaximaVia);
    }
    if (message.municipioId !== 0) {
      obj.municipioId = Math.round(message.municipioId);
    }
    if (message.bairro !== "") {
      obj.bairro = message.bairro;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RevGeo>, I>>(base?: I): RevGeo {
    return RevGeo.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RevGeo>, I>>(object: I): RevGeo {
    const message = createBaseRevGeo();
    message.resultado = object.resultado ?? 0;
    message.logradouro = object.logradouro ?? "";
    message.faixaNumeracao = object.faixaNumeracao ?? "";
    message.cep = object.cep ?? "";
    message.municipio = object.municipio ?? "";
    message.uf = object.uf ?? "";
    message.pais = object.pais ?? "";
    message.pavimentoTipo = object.pavimentoTipo ?? 0;
    message.velocidadeMaximaVia = object.velocidadeMaximaVia ?? 0;
    message.municipioId = object.municipioId ?? 0;
    message.bairro = object.bairro ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
